import JobLeftSidebarContainer from "../../../components/job/grid/JobLeftSidebar";

const JobLeftSidebar = () => {
  return <JobLeftSidebarContainer />;
};

export default JobLeftSidebar;
